import { crossSellProductPopin as sliderCrossSellProductPopin } from '../sliders/sliders';
export default function initCrossSellProductPopin() {
    sliderCrossSellProductPopin();
    const modal = document.querySelector('#cross-sell-product-modal');
    // On variant change
    modal.querySelectorAll('[data-component-name="select-variant"] .c-dropdown__item').forEach((el) => {
        el.addEventListener('click', () => {
            const input = el.querySelector('input');
            const variantImage = input.getAttribute('data-variant-image');
            const form = el.closest('form');
            // Update variant image
            const image = form.querySelector('img');
            image.src = variantImage;
            // Update size dropdown
            const variantHash = input.getAttribute('data-variant-hash');
            const sizeDropdown = form.querySelector('[data-component-name="select-size"]');
            let firstAvailableSize;
            sizeDropdown.querySelectorAll('.c-dropdown__item').forEach((item) => {
                if (item.getAttribute('data-variant-hash') !== variantHash) {
                    item.classList.add('sr-only');
                }
                else {
                    item.classList.remove('sr-only');
                    // Select first available size
                    if (!firstAvailableSize) {
                        const input = item.querySelector('input');
                        if (input.getAttribute('data-item-available') === '1') {
                            firstAvailableSize = input.value;
                            input.checked = true;
                            const buttonText = sizeDropdown.querySelector('.c-dropdown__text');
                            buttonText.textContent = input.getAttribute('data-item-size');
                        }
                    }
                }
            });
        });
    });
}
